export type PrimaryNavLink = {
  href: string;
  translationKey: string;
  visibility: "all" | "signedIn" | "signedOut";
};

// Defined separately from page components to avoid circular dependencies
export const primaryNavLinks: PrimaryNavLink[] = [
  { 
    href: "/browse", 
    translationKey: "nav.browse", 
    visibility: "all" 
  },
  { 
    href: "/dashboard", 
    translationKey: "nav.dashboard", 
    visibility: "signedIn" 
  },
  { 
    href: "/surveys", 
    translationKey: "nav.surveys", 
    visibility: "signedIn" 
  }
];
